import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';

export class ChangeStatusItem {
  constructor(fteEntryIds, year, month) {
    this.FteEntryIds = fteEntryIds || [];
    this.Year = year || null;
    this.Month = month || null;
    this.TargetStatus = '';
  }
}

class EditChangeStatusWindowDescription {
  static titleForCreate = 'Change FTE Entry Status';
  static titleForEdit = 'Change FTE Entry Status';
  static finishButtonLabel = 'Apply';
  static itemType = ChangeStatusItem;

  static serviceFunction = (edited) =>
    OutsourcedUserFteService.ChangeStatus({
      FteEntryIds: edited.FteEntryIds.length > 0 ? edited.FteEntryIds : undefined,
      Year: edited.FteEntryIds.length > 0 ? undefined : edited.Year,
      Month: edited.FteEntryIds.length > 0 ? undefined : edited.Month,
      TargetStatus: edited.TargetStatus,
    });

  static messageOnSuccess = 'Status changed successfully.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'Select Target Status',
      fields: [
        {
          fieldName: 'TargetStatus',
          label: 'Target Status',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: [
            { value: '', label: '-- Select --' },
            { value: 'Open', label: 'Open' },
            { value: 'Confirmed', label: 'Confirmed' },
          ],
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}

export default EditChangeStatusWindowDescription;
